import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  CUSTOMERS_PATH,
  CUSTOMERS_DETAIL_PATH,
  CUSTOMERS_DETAIL_ID_PATH,
} from "utils/constants/paths";

const Customers = Loadable(React.lazy(() => import("./View")));
const CustomersDetail = Loadable(React.lazy(() => import("./View/Detail")));

export const CustomersRoute: IRouteItem = {
  path: CUSTOMERS_PATH,
  iconName: "People",
  element: React.createElement(Customers),
  name: "Customers",
  accessKeys: ["Analyst", "Support"],
  children: [
    {
      name: "Detail",
      path: CUSTOMERS_DETAIL_PATH,
      element: "",
      showInDrawer: false,
    },
    {
      path: CUSTOMERS_DETAIL_ID_PATH,
      element: React.createElement(CustomersDetail),
      showInDrawer: false,
    },
  ],
};
